import _stafetCommonStepsProps from 'foundation/js/configurations/_stafetCommonStepsProps'
import { ref, computed, onBeforeMount } from 'vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import StafetPayment from '../StafetPayment/StafetPayment.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import { useStore } from 'vuex'
import nonEmptyStringValidator from 'foundation/js/inputValidators/nonEmptyStringValidator'
import emailValidator from 'foundation/js/inputValidators/emailValidator'
import nameValidator from 'foundation/js/inputValidators/nameValidator'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'
import fieldsConfig from './config/fieldsConfig'
import fieldValidator from 'foundation/js/stafet/fieldValidator'
import phoneValidator from 'foundation/js/inputValidators/phoneValidator'
import cvrValidator from 'foundation/js/inputValidators/cvrValidator'
import FormAddressField from "../FormAddressField/FormAddressField"

export default {
    name: 'StafetDonationStepVirksomhed',
    components: {
        FormInputTextField,
        FormCheckbox,
        StafetPayment,
        StafetActions,
        FormAddressField
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const companyName = ref('')
        const firstName = ref(props.userData?.firstName ?? '')
        const lastName = ref(props.userData?.lastName ?? '')
        const email = ref(props.userData?.email ?? '')
        const phone = ref(props.userData?.phone ?? '')
        const companyAddress = ref("")
        const companyPostalCode = ref("")
        const companyCity = ref("")
        const companyWebsite = ref('')
        const companyLogo = ref([])
        const isAnonymous = ref(false)
        const taxDeduction = ref(false)
        const cvr = ref('')

        const basket = computed(() => {
            return store.state.donation.basket
        })

        const basketTotalPrice = computed(() => {
            return store.state.donation.basketTotalPrice
        })

        const donationFor = computed(() => {
            return store.state.donation.donationFor
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'companyName')) {
                    companyName.value = getFieldValue(
                        storedFields,
                        'companyName'
                    )
                }
                if (getFieldValue(storedFields, 'firstName')) {
                    firstName.value = getFieldValue(storedFields, 'firstName')
                }
                if (getFieldValue(storedFields, 'lastName')) {
                    lastName.value = getFieldValue(storedFields, 'lastName')
                }
                if (getFieldValue(storedFields, 'email')) {
                    email.value = getFieldValue(storedFields, 'email')
                }
                if (getFieldValue(storedFields, 'phone')) {
                    phone.value = getFieldValue(storedFields, 'phone')
                }
                if (getFieldValue(storedFields, 'companyAddress')) {
                    companyAddress.value = getFieldValue(
                        storedFields,
                        'companyAddress'
                    )
                }
                if (getFieldValue(storedFields, 'companyPostalCode')) {
                    companyPostalCode.value = getFieldValue(
                        storedFields,
                        'companyPostalCode'
                    )
                }
                if (getFieldValue(storedFields, 'companyCity')) {
                    companyCity.value = getFieldValue(
                        storedFields,
                        'companyCity'
                    )
                }
                if (getFieldValue(storedFields, 'companyWebsite')) {
                    companyWebsite.value = getFieldValue(
                        storedFields,
                        'companyWebsite'
                    )
                }
                if (getFieldValue(storedFields, 'isAnonymous')) {
                    isAnonymous.value = getFieldValue(
                        storedFields,
                        'isAnonymous'
                    )
                }
                if (getFieldValue(storedFields, 'taxDeduction')) {
                    taxDeduction.value = getFieldValue(
                        storedFields,
                        'taxDeduction'
                    )
                }
                if (getFieldValue(storedFields, 'cvr')) {
                    cvr.value = getFieldValue(storedFields, 'cvr')
                }
            }

            validateField('firstName', firstName.value)
            validateField('cvr', cvr.value)
            validateField('taxDeduction', taxDeduction.value)
            validateField('isAnonymous', isAnonymous.value)
            validateField('companyWebsite', companyWebsite.value)
            validateField('companyAddress', companyAddress.value)
            validateField('companyPostalCode', companyPostalCode.value)
            validateField('companyCity', companyCity.value)
            validateField('phone', phone.value)
            validateField('email', email.value)
            validateField('lastName', lastName.value)
            validateField('companyName', companyName.value)
        })

        const showFirstNameErrorMessage = computed(() => {
            return !nameValidator(firstName.value) && props.displayInputError
        })

        const showLastNameErrorMessage = computed(() => {
            return !nameValidator(lastName.value) && props.displayInputError
        })

        const showEmailErrorMessage = computed(() => {
            return !emailValidator(email.value) && props.displayInputError
        })

        const showPhoneErrorMessage = computed(() => {
            return (
                phone.value !== '' &&
                props.displayInputError &&
                !phoneValidator(phone.value)
            )
        })

        const showCvrErrorMessage = computed(() => {
            return !cvrValidator(cvr.value) && props.displayInputError
        })

        const showCompanyNameErrorMessage = computed(() => {
            return (
                !nonEmptyStringValidator(companyName.value) &&
                props.displayInputError
            )
        })

        const showCompanyAddressErrorMessage = computed(() => {
            validateField('companyAddress', companyAddress.value)
            validateField('companyPostalCode', companyPostalCode.value)
            validateField('companyCity', companyCity.value)
            return (
                !addressValidator(companyAddress.value, companyPostalCode.value, companyCity.value) && 
                props.displayInputError
            )
        })

        const setTaxDeduction = (value) => {
            taxDeduction.value = value
            validateField('taxDeduction', value)
        }

        const validateField = (fieldName, value) => {
            fieldsConfig.find((item) => item.name === fieldName).value = value
            const field = fieldsConfig.find((field) => field.name === fieldName)
            if (field) {
                field.value = value
                fieldValidator(field)
            }
        }

        const addressValidator = (address, postalCode, city) => {
            return address && postalCode && city
        }

        const onFileChange = (e) => {
            const files = e.target.files
            companyLogo.value = files
            validateField('companyLogo', files)
        }

        const stepModel = computed(() => {
            return fieldsConfig
        })

        return {
            companyName,
            firstName,
            lastName,
            email,
            phone,
            companyAddress,
            companyPostalCode,
            companyCity,
            companyWebsite,
            companyLogo,
            isAnonymous,
            taxDeduction,
            cvr,
            basket,
            basketTotalPrice,
            showFirstNameErrorMessage,
            showLastNameErrorMessage,
            showEmailErrorMessage,
            showPhoneErrorMessage,
            showCvrErrorMessage,
            showCompanyNameErrorMessage,
            showCompanyAddressErrorMessage,
            stepModel,
            donationFor,
            onFileChange,
            setTaxDeduction,
            validateField,
            addressValidator
        }
    }
}
